import "./style/index.scss";
import { Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../util/hooks";
import { resetAll } from "../../../redux/actions/actions";
import { useEffect, useState } from "react";
import { MenuConfigItem } from "../../../models/sistema/menuConfigItem";
import { admin } from "./menus/admin";
import { auditoria } from "./menus/auditoria";
import { financeiroBase } from "./menus/financeiroBase";
import { consignatario } from "./menus/consignatario";
import { caixa } from "./menus/caixa";
import { contabilidade } from "./menus/contabilidade";
import { diretoria } from "./menus/diretoria";
import { corporativo } from "./menus/corporativo";
import { PersistedState } from "../../../redux/slices/persisted/persistedSlice";

const SiderMenu: React.FC = () => {
  //estados globais
  const persistedState: PersistedState = useAppSelector((state) => state.persisted);

  //hooks
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  //estados locais
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  //atualiza selectedKeys e openKeys com base na localização atual
  useEffect(() => {
    const { pathname } = location;
    setSelectedKeys([pathname]);

    const openKeys = findUserMenu(persistedState.user.perfil).reduce<string[]>((keys, item) => {
      if (item.children && item.children.some((child) => child.key === pathname)) {
        if (item.key) keys.push(item.key);
      }
      return keys;
    }, []);
    setOpenKeys(openKeys);
  }, [location]);

  //função para gerar os itens do menu de forma recursiva
  const generateMenuItems = (items: MenuConfigItem[]): any[] => {
    return items.map((item) => {
      if (item.children && item.children.length > 0) {
        return {
          key: item.key,
          icon: item.icon,
          label: item.label,
          children: generateMenuItems(item.children),
        };
      }
      return {
        key: item.key,
        icon: item.icon,
        label: item.label,
        type: item.type,
      };
    });
  };

  const onMenuClick = (e: { key: string }) => {
    const clickedItem = findMenuItemByKey(findUserMenu(persistedState.user.perfil), e.key);
    if (clickedItem?.path && clickedItem.path !== selectedKeys[0]) {
      // Reinicia estado das telas ao navegar no menu
      dispatch(resetAll());
      navigate(clickedItem.path);
    }
  };

  const onOpenChange = (keys: string[]) => {
    setOpenKeys(keys);
  };

  //função para encontrar um item do menu pela chave
  const findMenuItemByKey = (items: MenuConfigItem[], key: string): MenuConfigItem | undefined => {
    for (const item of items) {
      if (item.key === key) {
        return item;
      }
      if (item.children) {
        const found = findMenuItemByKey(item.children, key);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  };

  //função para encontrar o menu do usuário com base no perfil
  const findUserMenu = (perfil: string): MenuConfigItem[] => {
    switch (perfil) {
      case "ADMIN":
        return admin;
      case "AUDITORIA":
        return auditoria;
      case "FINANCEIRO BASE":
        return financeiroBase;
      case "CONSIGNATARIO":
        return consignatario;
      case "CAIXA":
        return caixa;
      case "CONTABILIDADE":
        return contabilidade;
      case "DIRETORIA":
        return diretoria;
      case "CORPORATIVO":
        return corporativo;
      default:
        return admin;
    }
  };

  return (
    <Menu
      selectedKeys={selectedKeys}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      onClick={onMenuClick}
      mode="inline"
      items={generateMenuItems(findUserMenu(persistedState.user.perfil))}
      className="menu"
      forceSubMenuRender
    />
  );
};

export default SiderMenu;
